import React, { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { IconProps } from './iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default function IconRestore({
  extColor,
  isAutoscallable = true,
  sizeKey = '16x16',
  onClick,
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.text.secondary;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={cx('icon', { 'icon-disabled': !onClick })}
      viewBox="0 0 16 16"
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      fill={fill}
    >
      <path d="M3.27699 2.03277C3.10928 2.09534 2.89402 2.31561 2.82894 2.49583C2.77888 2.636 2.77638 2.67605 2.77638 3.99014C2.77638 5.30424 2.77888 5.34429 2.82894 5.48446C2.86899 5.58958 2.92155 5.66718 3.02418 5.7673C3.26197 6.00008 3.19939 5.99257 4.80384 5.99257H6.19303L6.32068 5.9325C6.5009 5.8499 6.64357 5.71223 6.72367 5.54703C6.78124 5.42689 6.79125 5.37182 6.79125 5.1916C6.79125 5.01138 6.78124 4.95631 6.72367 4.83617C6.64357 4.67097 6.5009 4.5333 6.32068 4.4507C6.20554 4.39814 6.15798 4.39063 5.8426 4.39063H5.49217L5.66739 4.27549C6.82129 3.52207 8.4007 3.39942 9.70729 3.9576C11.0689 4.54081 12.0501 5.7723 12.3155 7.23408C12.3931 7.65709 12.3931 8.33291 12.3155 8.75593C11.8374 11.3941 9.14411 12.9986 6.60603 12.1576C4.99157 11.6244 3.83016 10.1827 3.62741 8.45806C3.58736 8.12766 3.52729 7.97248 3.37711 7.81979C3.06673 7.51192 2.53609 7.51192 2.22571 7.81979C2.00294 8.04506 1.95538 8.31289 2.03798 8.87857C2.19067 9.89481 2.58865 10.8284 3.23443 11.687C3.44469 11.9648 4.06544 12.5781 4.36581 12.8008C5.25188 13.4641 6.2556 13.8596 7.35193 13.9773C7.76243 14.0223 8.63849 13.9973 9.00894 13.9297C10.5783 13.6469 11.9225 12.8108 12.8661 11.5343C13.4268 10.7734 13.8298 9.75714 13.9675 8.74591C13.9875 8.61325 14 8.27785 14 7.995C14 7.71216 13.9875 7.37675 13.9675 7.24409C13.7772 5.8524 13.1515 4.60839 12.1728 3.66475C11.2992 2.82373 10.2329 2.28307 8.99643 2.05529C8.73361 2.00774 8.61096 2.00023 7.99521 2.00023C7.23429 2.00023 7.07409 2.01775 6.5059 2.16292C5.82007 2.33563 5.12423 2.64851 4.58607 3.02897C4.50097 3.08905 4.42588 3.13911 4.42087 3.13911C4.41587 3.13911 4.40335 3.01145 4.39835 2.85627C4.38833 2.61848 4.37832 2.5559 4.31825 2.43325C4.24066 2.26805 4.09798 2.13289 3.91776 2.04778C3.76007 1.9752 3.4547 1.96769 3.27699 2.03277Z" />{' '}
    </svg>
  );
}
